// Utilitaires partagés entre googleSecureAuthService.ts et
// passwordSecureAuthService.ts — pendants frontend de
// proxy-server/routes/secureAuthCore.js. Rien de spécifique à un provider
// ici, juste l'appel réseau commun et la finalisation via customToken.
import { getAuth, signInWithCustomToken, type User } from 'firebase/auth';
import { API_BASE_URL } from '../config/api';

export async function postJson<T>(path: string, body: object): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Erreur de connexion au serveur');
  }
  return data as T;
}

/** N'appelé qu'une fois le serveur a validé identité + challenge(s) requis — voir secureAuthCore.js. */
export async function finishWithCustomToken(customToken: string): Promise<User> {
  const credential = await signInWithCustomToken(getAuth(), customToken);
  return credential.user;
}

export interface AuthChallenge {
  requiresDevice: boolean;
  requiresTotp: boolean;
  cooldownSeconds?: number;
}

export type ChallengeOutcome =
  | { status: 'authenticated'; user: User }
  | { status: 'challenge'; challenge: AuthChallenge };

/** Résout la réponse commune de /verify-device et /verify-totp (les deux providers). */
export async function toChallengeOutcome(data: any): Promise<ChallengeOutcome> {
  if (data.status === 'authenticated') {
    const user = await finishWithCustomToken(data.customToken);
    return { status: 'authenticated', user };
  }
  return {
    status: 'challenge',
    challenge: { requiresDevice: !!data.requiresDevice, requiresTotp: !!data.requiresTotp },
  };
}
